import { useContext, useEffect, useState, useRef } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import axios from 'axios';

import { clearCache } from 'global/util';
import { fetchSiteMenu, fetchSiteMobileMenu } from 'global/queries';
import { availablesMenus } from 'global/utilsMenu';

import { UserContext } from 'contexts/UserContext';
import { ContactContext } from 'contexts/ContactContext';

import useWidth from 'hooks/useWidth';

import styles from './global_menu_bar.module.scss';

import { ReactComponent as MenuBars } from 'assets/menu_mobile/menu.svg';
import { ReactComponent as MenuClose } from 'assets/close.svg';
import { ReactComponent as MenuUser } from 'assets/menu_mobile/profile.svg';
import { ReactComponent as GeoLogoWhite } from 'assets/geolocaux-extend-white.svg';
import { ReactComponent as ServicePro } from 'assets/menu_mobile/circle-plus.svg';
import { BiLogOutCircle } from 'react-icons/bi';

const GlobalMenuBar = () => {
  const [megaMenu, setMegaMenu] = useState(null);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const width = useWidth();
  const [menus, setMenus] = useState([]);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { user, setIsLogged } = useContext(UserContext);

  // ^ Menu tel qu'il est dans le site en RAW <== virer les obfuscation & les hide && ref à auth
  const [nav_links, setNavLinks] = useState([
    {
      menu_key: 'loc',
      label: 'Louer',
      label_mobile: 'Annonces en location',
      title: 'Louer',
      to: null,
      classList: 'location',
      submenu: [
        {
          label: 'Location de bureaux',
          title: 'Location de bureaux',
          classList: 'location_bureau',
          image: '/images/menu/bureau.svg',
          to: '/location/bureau/',
          submenu: [
            {
              label: 'Tous les bureaux à louer',
              title: 'Tous les bureaux à louer',
              to: '/location/bureau/',
              mobile_only: true
            },
            {
              label: 'Location bureaux à Paris',
              title: 'Location bureaux à Paris',
              classList: '',
              to: '/location/bureau/paris-75/'
            },
            {
              label: 'Location bureaux à Lyon',
              title: 'Location bureaux à Lyon',
              to: '/location/bureau/lyon-69000/'
            },
            {
              label: 'Location bureaux à Marseille',
              title: 'Location bureaux à Marseille',
              to: '/location/bureau/marseille-13000/'
            },
            {
              label: 'Location bureaux à Bordeaux',
              title: 'Location bureaux à Bordeaux',
              to: '/location/bureau/bordeaux-33000/'
            },
            {
              label: 'Location bureaux à Toulouse',
              title: 'Location bureaux à Toulouse',
              to: '/location/bureau/toulouse-31000/'
            }
          ]
        },
        {
          label: 'Coworking à louer',
          title: 'Coworking à louer',
          classList: 'coworking',
          image: '/images/menu/coworking.svg',
          to: '/coworking/',
          submenu: [
            {
              label: 'Tous les coworking',
              title: 'Tous les coworking',
              to: '/coworking/',
              mobile_only: true
            },
            {
              label: 'Coworking à Paris',
              title: 'Coworking à Paris',
              to: '/coworking/paris-75/'
            },
            {
              label: 'Coworking à Lyon',
              title: 'Coworking à Lyon',
              to: '/coworking/lyon-69000/'
            },
            {
              label: 'Coworking à Marseille',
              title: 'Coworking à Marseille',
              to: '/coworking/marseille-13000/'
            },
            {
              label: 'Coworking à Bordeaux',
              title: 'Coworking à Bordeaux',
              to: '/coworking/bordeaux-33000/'
            },
            {
              label: 'Coworking à Toulouse',
              title: 'Coworking à Toulouse',
              to: '/coworking/toulouse-31000/'
            }
          ]
        },
        {
          label: `Entrepôts et locaux d'activité à louer`,
          title: `Entrepôts et locaux d'activité à louer`,
          classList: 'entrepot',
          image: '/images/menu/entrepot.svg',
          to: '/location/entrepot/',
          submenu: [
            {
              label: 'Tous les entrepôts à louer',
              title: 'Tous les entrepôts à louer',
              to: '/location/entrepot/',
              mobile_only: true
            },
            {
              label: 'Location entrepôt en Seine-Saint-Denis',
              title: 'Location entrepôt en Seine-Saint-Denis',
              to: '/location/entrepot/seine-saint-denis-93/'
            },
            {
              label: 'Location entrepôt Haute-Garonne',
              title: 'Location entrepôt Haute-Garonne',
              to: '/location/entrepot/haute-garonne-31/'
            },
            {
              label: 'Location entrepôt Bouches-du-Rhône',
              title: 'Location entrepôt Bouches-du-Rhône',
              to: '/location/entrepot/bouches-du-rhone-13/'
            },
            {
              label: 'Location entrepôt Gironde',
              title: 'Location entrepôt Gironde',
              to: '/location/entrepot/gironde-33/'
            }
          ]
        },
        {
          label: `Locaux commerciaux à louer`,
          title: `Locaux commerciaux à louer`,
          classList: 'locaux',
          image: '/images/menu/local-commercial.svg',
          to: '/location/local-commercial/',
          submenu: [
            {
              label: 'Toutes les locaux commerciaux à louer',
              title: 'Toutes les locaux commerciaux à louer',
              to: '/location/local-commercial/',
              mobile_only: true
            },
            {
              label: 'Location local commercial à Paris',
              title: 'Location local commercial à Paris',
              to: '/location/local-commercial/paris-75/'
            },
            {
              label: 'Location local commercial à Lyon',
              title: 'Location local commercial à Lyon',
              to: '/location/local-commercial/lyon-69000/'
            },
            {
              label: 'Location local commercial à Marseille',
              title: 'Location local commercial à Marseille',
              to: '/location/local-commercial/marseille-13000/'
            },
            {
              label: 'Location local commercial à Bordeaux',
              title: 'Location local commercial à Bordeaux',
              to: '/location/local-commercial/bordeaux-33000/'
            }
          ]
        }
      ]
    },
    {
      menu_key: 'ven',
      label: 'Acheter',
      label_mobile: 'Annonces en vente',
      title: 'Acheter',
      to: null,
      classList: 'vente',
      submenu: [
        {
          label: 'Achat de bureaux',
          title: 'Achat de bureaux',
          classList: 'achat_bureau',
          image: '/images/menu/bureau.svg',
          to: '/vente/bureau/',
          submenu: [
            {
              label: 'Tous les bureaux à vendre',
              title: 'Tous les bureaux à vendre',
              to: '/vente/bureau/',
              mobile_only: true
            },
            {
              label: 'Achat bureaux à Paris',
              title: 'Achat bureaux à Paris',
              classList: '',
              to: '/vente/bureau/paris-75/'
            },
            {
              label: 'Achat bureaux à Lyon',
              title: 'Achat bureaux à Lyon',
              to: '/vente/bureau/lyon-69000/'
            },
            {
              label: 'Achat bureaux à Marseille',
              title: 'Achat bureaux à Marseille',
              to: '/vente/bureau/marseille-13000/'
            },
            {
              label: 'Achat bureaux à Bordeaux',
              title: 'Achat bureaux à Bordeaux',
              to: '/vente/bureau/bordeaux-33000/'
            },
            {
              label: 'Achat bureaux à Toulouse',
              title: 'Achat bureaux à Toulouse',
              to: '/vente/bureau/toulouse-31000/'
            }
          ]
        },
        {
          label: `Entrepôts et locaux d'activité à vendre`,
          title: `Entrepôts et locaux d'activité à vendre`,
          classList: 'entrepot',
          image: '/images/menu/entrepot.svg',
          to: '/vente/entrepot/',
          submenu: [
            {
              label: 'Tous les entrepôts à vendre',
              title: 'Tous les entrepôts à vendre',
              to: '/vente/entrepot/',
              mobile_only: true
            },
            {
              label: 'Vente entrepôt en Seine-Saint-Denis',
              title: 'Vente entrepôt en Seine-Saint-Denis',
              to: '/vente/entrepot/seine-saint-denis-93/'
            },
            {
              label: 'Vente entrepôt Haute-Garonne',
              title: 'Vente entrepôt Haute-Garonne',
              to: '/vente/entrepot/haute-garonne-31/'
            },
            {
              label: 'Vente entrepôt Bouches-du-Rhône',
              title: 'Vente entrepôt Bouches-du-Rhône',
              to: '/vente/entrepot/bouches-du-rhone-13/'
            },
            {
              label: 'Vente entrepôt Gironde',
              title: 'Vente entrepôt Gironde',
              to: '/vente/entrepot/gironde-33/'
            }
          ]
        },
        {
          label: `Locaux commerciaux à vendre`,
          title: `Locaux commerciaux à vendre`,
          classList: 'locaux',
          image: '/images/menu/local-commercial.svg',
          to: '/vente/local-commercial/',
          submenu: [
            {
              label: 'Tous les locaux commerciaux à vendre',
              title: 'Tous les locaux commerciaux à vendre',
              to: '/vente/local-commercial/',
              mobile_only: true
            },
            {
              label: 'Vente local commercial à Paris',
              title: 'Vente local commercial à Paris',
              to: '/vente/local-commercial/paris-75/'
            },
            {
              label: 'Vente local commercial à Lyon',
              title: 'Vente local commercial à Lyon',
              to: '/vente/local-commercial/lyon-69000/'
            },
            {
              label: 'Vente local commercial à Marseille',
              title: 'Vente local commercial à Marseille',
              to: '/vente/local-commercial/marseille-13000/'
            },
            {
              label: 'Vente local commercial à Bordeaux',
              title: 'Vente local commercial à Bordeaux',
              to: '/vente/local-commercial/bordeaux-33000/'
            }
          ]
        },
        {
          label: `Fonds de commerce à vendre`,
          title: `Fonds de commerce à vendre`,
          classList: 'commerce',
          image: '/images/menu/fonds-commerce.svg',
          to: '/vente/fonds-de-commerce/',
          submenu: [
            {
              label: 'Tous les fonds de commerce à vendre',
              title: 'Tous les fonds de commerce à vendre',
              to: '/vente/fonds-de-commerce/',
              mobile_only: true
            },
            {
              label: 'Vente fonds de commerce à Paris',
              title: 'Vente fonds de commerce à Paris',
              to: '/vente/fonds-de-commerce/paris-75/'
            },
            {
              label: 'Vente fonds de commerce à Lyon',
              title: 'Vente fonds de commerce à Lyon',
              to: '/vente/fonds-de-commerce/lyon-69000/'
            },
            {
              label: 'Vente fonds de commerce à Marseille',
              title: 'Vente fonds de commerce à Marseille',
              to: '/vente/fonds-de-commerce/marseille-13000/'
            },
            {
              label: 'Vente fonds de commerce à Bordeaux',
              title: 'Vente fonds de commerce à Bordeaux',
              to: '/vente/fonds-de-commerce/bordeaux-33000/'
            }
          ]
        }
      ]
    },
    {
      label: 'Trouver une agence',
      title: 'Trouver une agence',
      to: '/agences-immobilier-entreprise/',
      classList: 'partenaires',
      menu_key: 'partenaires',
      image_mobile: '/images/menu/transaction.svg'
    },
    {
      label: 'Blog',
      title: 'Notre blog',
      to: 'https://www.geolocaux.com/blog/',
      classList: 'blog',
      menu_key: 'blog',
      image_mobile: '/images/menu/blog.svg'
    },
    {
      label: 'Services pro',
      title: 'Nos services',
      classList: 'service_pro',
      to: '/services/professionnel/',
      side: true,
      hide: true,
      menu_key: 'services_pro',
      submenu: [
        {
          label: `Diffusion d'annonces`,
          title: `Diffusion d'annonces`,
          classList: 'diffusion_annonces',
          image: '/images/menu/service_pro/diffusion-annonces.svg',
          image_mobile: '/images/menu/service_pro/diffusion-annonces.svg',
          to: '/services/professionnel/diffusion-annonces.html',
          text: `Bureaux, entrepôts, commerces, terrains... Tout l'immobilier d'entreprise est sur Geolocaux.com ! `
        },
        {
          label: `Mes employés`,
          title: `Mes employés`,
          classList: 'mes_employes',
          image: '/images/menu/service_pro/mes-employes.svg',
          image_mobile: '/images/menu/service_pro/mes-employes.svg',
          to: '/services/professionnel/mes-employes.html',
          text: `Études pour connaître et optimiser le trajet domicile-travail de vos salariés`
        },
        {
          label: `Publicité premium`,
          title: `Publicité premium`,
          classList: 'publicite_premium',
          image: '/images/menu/service_pro/bup-premium.svg',
          image_mobile: '/images/menu/service_pro/bup-premium.svg',
          to: '/services/professionnel/publicite-premium.html',
          text: `Gagnez en visbilité en intégrant une bannière exclusive sur votre secteur !`
        }
      ]
    },
    {
      label:
        user.is_pro &&
        user.abonnement != null &&
        user.abonnement.date_abo != null
          ? user.from_flux
            ? `Mes annonces`
            : `Publier des annonces`
          : `Publier des annonces`,
      title:
        user.is_pro &&
        user.abonnement != null &&
        user.abonnement.date_abo != null
          ? user.from_flux
            ? `Mes annonces`
            : `Publier des annonces`
          : `Publier des annonces`,
      classList: 'publication_annonce',
      to:
        user.is_pro &&
        user.abonnement != null &&
        user.abonnement.date_abo != null
          ? `${process.env.REACT_APP_ACCOUNT_URL}/annonces`
          : '/services/professionnel/diffusion-annonces.html',
      mobile: true, //aussi dans le header en mobile
      side: true,
      menu_key: 'publish',
      image_mobile: '/images/menu/circle-plus.svg',
      image_before: ServicePro
    }
  ]);

  const [mobile_menu, setMobileMenu] = useState([
    ...nav_links.filter((n) => n.menu_key === 'loc'),
    ...nav_links.filter((n) => n.menu_key === 'ven'),
    ...nav_links.filter((n) => n.menu_key === 'partenaires'),
    //...nav_links.filter((n) => n.menu_key === 'services_pro'),
    ...nav_links.filter((n) => n.menu_key === 'blog'),
    {
      menu_key: 'service_pro',
      label: 'Services pro',
      title: 'Nos services',
      classList: 'service_pro',
      to: '/services/professionnel/',
      side: true,
      menu_key: 'services_pro',
      image_mobile: '/images/icons/service_pro/bup-premium.svg'
    },
    {
      label: `Diffusion d'annonces`,
      title: `Diffusion d'annonces`,
      classList: 'diffusion_annonces',
      menu_key: 'diffusion_annonces',
      image: '/images/icons/service_pro/diffusion-annonces.svg',
      image_mobile: '/images/icons/service_pro/diffusion-annonces.svg',
      to: '/services/professionnel/diffusion-annonces.html',
      text: `Bureaux, entrepôts, commerces, terrains... Tout l'immobilier d'entreprise est sur Geolocaux.com ! `
    }
  ]);

  useEffect(() => {
    setMenus(availablesMenus(location.pathname, user));
  }, [user, location.pathname]);

  const { showFormContact, setShowFormContact, message, setMessage } =
    useContext(ContactContext);

  useEffect(
    (_) => {
      if (showFormContact) setMobileMenuVisible(false);
    },
    [showFormContact]
  );

  const handleLogout = async () => {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/logout`,
      {},
      { withCredentials: true }
    );
    setIsLogged(false);
    queryClient.removeQueries();
    clearCache();
  };

  return (
    <>
      <header className={styles.wrapper}>
        <a
          href={`${process.env.REACT_APP_SITE_URL}`}
          className={styles.logo}
          title="Geolocaux - Location et vente d'immobilier pro"
        >
          <GeoLogoWhite
            alt="Geolocaux - Location et vente d'immobilier pro"
            width={124}
            height={22}
          />
        </a>
        <nav>
          <ul>
            {nav_links
              .filter((x) => !x.side)
              .map((l) => (
                <HeaderLink key={l.menu_key} link={l} />
              ))}
          </ul>
        </nav>
        <div className={styles.side}>
          <ul>
            {user &&
              user.favori_enabled &&
              user.favoris &&
              user.favoris.length > 0 && (
                <HeaderLink
                  link={{
                    to: `${process.env.REACT_APP_ACCOUNT_URL}/favoris`,
                    label: 'Mes favoris',
                    title: 'Mes favoris',
                    classList: 'favoris'
                  }}
                />
              )}

            {nav_links
              .filter((x) => x.side)
              .map((l) => (
                <HeaderLink key={l.menu_key} link={l} />
              ))}
          </ul>
          <span className={styles.account}>
            <MenuUser
              onClick={() => {
                navigate('/accueil');
              }}
            />
            <ul className={styles.submenu}>
              {menus.map((menu, key) => (
                <li key={key}>
                  <NavLink
                    className={(navData) =>
                      `${styles.linkWrapper}${
                        menu.isActive() ? ` ${styles.selected}` : ''
                      }`
                    }
                    to={menu.to}
                  >
                    {menu.global}
                  </NavLink>
                </li>
              ))}
              <li className={styles.logout + ' ' + styles.liLogout}>
                <a
                  onClick={() => handleLogout()}
                  title="Déconnexion"
                  className={styles.logout}
                >
                  <BiLogOutCircle /> Déconnexion
                </a>
              </li>
            </ul>
          </span>
          {width < 1024 && (
            <span className={styles.sideMenu}>
              {mobileMenuVisible ? (
                <MenuClose
                  onClick={(_) => {
                    setMobileMenuVisible(false);
                  }}
                />
              ) : (
                <MenuBars
                  onClick={(_) => {
                    setMobileMenuVisible(true);
                    if (showFormContact) setShowFormContact(false);
                  }}
                />
              )}
            </span>
          )}

          {/* {width < 1024 && (
            <>
              <div
                className={`${styles.sideMenu} ${
                  mobileMenuVisible ? styles.open : ''
                }`}
                onClick={() => setMobileMenuVisible(!mobileMenuVisible)}
              />

              {mobileMenuVisible &&
                createPortal(
                  <div id="MobileMenu" className={styles.mobileMenu}>
                    {mobile_menu.map((lkMenu) => (
                      <HeaderLinkMobile
                        key={lkMenu.menu_key}
                        link={lkMenu}
                        onNavigate={() => {
                          setMobileMenuVisible(false);
                        }}
                      />
                    ))}
                  </div>,
                  document.body
                )}
            </>
          )} */}
        </div>

        {/* {width >= 1024 && (
          <nav>
            <ul>
              <li className="has_sub">
                <a href={`${process.env.REACT_APP_SITE_URL}/location/bureau/`}>
                  Louer
                </a>
              </li>
              <li className="has_sub">
                <a href={`${process.env.REACT_APP_SITE_URL}/vente/bureau/`}>
                  Acheter
                </a>
              </li>

              <li className="has_sub services">
                <a
                  title="Nos services"
                  href={`${process.env.REACT_APP_SITE_URL}/services/professionnel/`}
                >
                  Services pro
                </a>
              </li>
              <li className="agencies">
                <a
                  href={`${process.env.REACT_APP_SITE_URL}/agences-immobilier-entreprise/`}
                  title="Trouver une agence"
                >
                  Trouver une agence
                </a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_SITE_URL}/blog/`}>Blog</a>
              </li>
            </ul>
          </nav>
        )}

        <div className={styles.right}>
          {width >= 1024 ? (
            <>
              <a
                className={styles.depot}
                href={`${process.env.REACT_APP_SITE_URL}/services/professionnel/diffusion-annonces.html`}
                title="Publiez votre annonce sur la plateforme Geolocaux.com"
              >
                Publication d'annonces
              </a>
              <ul>
                <li className={styles.accmpt}>
                  <NavLink className={styles.glUser} to="/accueil">
                    <MenuUser />
                  </NavLink>
                  <span className={styles.glAngleDown}></span>
                  <ul>
                    {menus.map((menu, key) => (
                      <li key={key}>
                        <NavLink
                          className={(navData) =>
                            `${styles.linkWrapper}${
                              menu.isActive() ? ` ${styles.selected}` : ''
                            }`
                          }
                          to={menu.to}
                        >
                          {menu.global}
                        </NavLink>
                      </li>
                    ))}
                    <li className={styles.logout + ' ' + styles.liLogout}>
                      <a
                        onClick={() => handleLogout()}
                        title="Déconnexion"
                        className={styles.logout}
                      >
                        <BiLogOutCircle /> Déconnexion
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </>
          ) : mobileMenuVisible ? (
            <MenuClose
              className={`${styles.menuBars} ${styles.menuBarsClose}`}
              onClick={(_) => {
                setMobileMenuVisible(false);
              }}
            />
          ) : (
            <MenuBars
              className={styles.menuBars}
              onClick={(_) => {
                setMobileMenuVisible(true);
                if (showFormContact) setShowFormContact(false);
              }}
            />
          )}
        </div> */}
        {mobileMenuVisible && width < 1024 && (
          <div id="MobileMenu" className={styles.mobileMenu}>
            {mobile_menu.map((lkMenu) => (
              <HeaderLinkMobile
                key={lkMenu.menu_key}
                link={lkMenu}
                onNavigate={() => {
                  setMobileMenuVisible(false);
                }}
              />
            ))}
          </div>
        )}
      </header>
    </>
  );
};

export default GlobalMenuBar;

export const HeaderLinkMobile = ({ link, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const nodeRef = useRef(null);

  const handleClick = () => {
    if (link.submenu) {
      setOpen(!open);
    }
  };

  return (
    <>
      {!!link.to && !link.submenu ? (
        <a
          href={
            link.to.startsWith('/')
              ? process.env.REACT_APP_SITE_URL + link.to
              : link.to
          }
          className={`row ${!!link.submenu ? 'sub' : ''} ${
            !!link.submenu && open ? 'open' : ''
          }`}
          onClick={handleClick}
        >
          <span
            data-menuimg={`${
              !!link.submenu
                ? '/assets/chevron.svg'
                : link.image_mobile || '/assets/chevron.svg'
            }`}
          />
          {link.label_mobile || link.label}
        </a>
      ) : (
        <div
          className={`row ${!!link.submenu ? 'sub' : ''} ${
            !!link.submenu && open ? 'open' : ''
          }`}
          onClick={handleClick}
        >
          <span
            data-menuimg={`${
              !!link.submenu
                ? '/assets/chevron.svg'
                : link.image_mobile || '/assets/chevron.svg'
            }`}
          />
          {link.label_mobile || link.label}
        </div>
      )}
      <CSSTransition
        nodeRef={nodeRef}
        in={open && !!link.submenu}
        timeout={{
          enter: 340,
          exit: 220
        }}
        classNames="menu"
        unmountOnExit
      >
        <ul>
          {link.submenu?.map((lk, index) => (
            <li key={index}>
              {!lk.submenu ? (
                <a
                  href={
                    !!lk.to && lk.to.startsWith('/')
                      ? process.env.REACT_APP_SITE_URL + lk.to
                      : lk.to
                  }
                  onClick={onNavigate}
                >
                  {lk.image_mobile && <span data-menuimg={lk.image_mobile} />}
                  {lk.label}
                </a>
              ) : (
                <div className="submenu">
                  <span className="sub_title">{lk.label}</span>
                  <ul className="sub_list">
                    {lk.submenu.map((sub, subIndex) => (
                      <li key={subIndex}>
                        <a
                          href={
                            sub.to.startsWith('/')
                              ? process.env.REACT_APP_SITE_URL + sub.to
                              : sub.to
                          }
                          onClick={onNavigate}
                        >
                          {sub.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          ))}
        </ul>
      </CSSTransition>
    </>
  );
};

export const HeaderLink = ({ link, onNavigate }) => {
  const [isOn, setIsOn] = useState(false);
  const timer = useRef(null);

  const filteredSubmenu =
    link.submenu?.filter((item) => !item.mobile_only) || [];
  const hasSubmenu = filteredSubmenu.length > 0;

  const enter = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      setIsOn(true);
    }, 10);
  };

  const leave = () => {
    setIsOn(false);
  };

  const handleSubNavigation = () => {
    leave();
    if (onNavigate) onNavigate();
  };

  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  if (link.hide) return null;

  return (
    <li
      className={`${styles.header_link} ${isOn ? styles.on : ''} ${
        link.classList || ''
      }`}
      onMouseEnter={enter}
      onMouseLeave={leave}
      onClick={leave}
    >
      {link.to ? (
        <a
          href={
            link.to.startsWith('/')
              ? process.env.REACT_APP_SITE_URL + link.to
              : link.to
          }
          className={`${styles.header_link_content}`}
          onClick={() => onNavigate && onNavigate()}
        >
          {link.image_before && (
            <span className={`${styles.header_link_image_before}`}>
              <link.image_before />
            </span>
          )}
          {link.image && (
            <picture>
              <img src={link.image} alt={link.label} loading="lazy" />
            </picture>
          )}
          {link.label}
          {link.text && (
            <span className={`${styles.header_link_description}`}>
              {link.text}
            </span>
          )}
        </a>
      ) : link.image ? (
        <div className={`${styles.header_link_content}`}>
          <picture>
            <img src={link.image} alt={link.label} loading="lazy" />
          </picture>
          {link.label}
          {link.text && (
            <span className={`${styles.header_link_description}`}>
              {link.text}
            </span>
          )}
        </div>
      ) : (
        <span className={`${styles.header_link_content}`}>
          {link.label}
          {link.text && (
            <span className={`${styles.header_link_description}`}>
              {link.text}
            </span>
          )}
        </span>
      )}

      {hasSubmenu && (
        <ul className={styles.header_link_submenu}>
          {filteredSubmenu.map((sublink, index) => (
            <HeaderLink
              key={index}
              link={sublink}
              onNavigate={handleSubNavigation}
            />
          ))}
        </ul>
      )}
    </li>
  );
};
